import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("categoryView", {params: params});
  },

  findById(id) {
    return httpService.get("categoryView/" + id);
  },

  findAllByCategoryCodeAndGroupCode(categoryCode, groupCode) {
    let params = {categoryCode: categoryCode, groupCode: groupCode};
    return httpService.get("categoryView/findAllByCategoryCodeAndGroupCode", {params: params});
  },

  findAllByGroupCode(groupCode) {
    let params = {groupCode: groupCode};
    return httpService.get("categoryView/findAllByGroupCode", {params: params});
  }
};



// WEBPACK FOOTER //
// ./src/services/categoryViewService.js